import { Button, ButtonProps } from "@mui/material"
import './Button.scss';

const CustomButton = ({children, variant = 'contained', ...props}: ButtonProps) => {
  return (
    <Button {...props} className="customButton" variant={variant}>
        {children}
    </Button>
  )
}

export default CustomButton
